// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAggregatorManualContributionRecordDto
 */
export interface IAggregatorManualContributionRecordDto {
    /**
     * 
     * @type {Date}
     * @memberof IAggregatorManualContributionRecordDto
     */
    contribution_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IAggregatorManualContributionRecordDto
     */
    tax_type?: IAggregatorManualContributionRecordDtoTaxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAggregatorManualContributionRecordDto
     */
    tax_year?: string;
    /**
     * 
     * @type {number}
     * @memberof IAggregatorManualContributionRecordDto
     */
    employee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IAggregatorManualContributionRecordDto
     */
    employer_contribution_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IAggregatorManualContributionRecordDto
     */
    ee_contribution_tag?: string;
    /**
     * 
     * @type {string}
     * @memberof IAggregatorManualContributionRecordDto
     */
    er_contribution_tag?: string;
    /**
     * 
     * @type {number}
     * @memberof IAggregatorManualContributionRecordDto
     */
    plan_id: number;
    /**
     * 
     * @type {string}
     * @memberof IAggregatorManualContributionRecordDto
     */
    plan_code: string;
    /**
     * 
     * @type {string}
     * @memberof IAggregatorManualContributionRecordDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IAggregatorManualContributionRecordDto
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof IAggregatorManualContributionRecordDto
     */
    employee_full_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IAggregatorManualContributionRecordDto
     */
    memo?: string;
}

/**
* @export
* @enum {string}
*/
export enum IAggregatorManualContributionRecordDtoTaxTypeEnum {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX'
}


/**
 * Check if a given object implements the IAggregatorManualContributionRecordDto interface.
 */
export function instanceOfIAggregatorManualContributionRecordDto(value: object): value is IAggregatorManualContributionRecordDto {
    if (!('plan_id' in value) || value['plan_id'] === undefined) return false;
    if (!('plan_code' in value) || value['plan_code'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    return true;
}

export function IAggregatorManualContributionRecordDtoFromJSON(json: any): IAggregatorManualContributionRecordDto {
    return IAggregatorManualContributionRecordDtoFromJSONTyped(json, false);
}

export function IAggregatorManualContributionRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAggregatorManualContributionRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contribution_date': json['contribution_date'] == null ? undefined : (new Date(json['contribution_date'])),
        'tax_type': json['tax_type'] == null ? undefined : json['tax_type'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'employee_contribution_amount': json['employee_contribution_amount'] == null ? undefined : json['employee_contribution_amount'],
        'employer_contribution_amount': json['employer_contribution_amount'] == null ? undefined : json['employer_contribution_amount'],
        'ee_contribution_tag': json['ee_contribution_tag'] == null ? undefined : json['ee_contribution_tag'],
        'er_contribution_tag': json['er_contribution_tag'] == null ? undefined : json['er_contribution_tag'],
        'plan_id': json['plan_id'],
        'plan_code': json['plan_code'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'employee_id': json['employee_id'],
        'employee_full_name': json['employee_full_name'] == null ? undefined : json['employee_full_name'],
        'memo': json['memo'] == null ? undefined : json['memo'],
    };
}

export function IAggregatorManualContributionRecordDtoToJSON(json: any): IAggregatorManualContributionRecordDto {
    return IAggregatorManualContributionRecordDtoToJSONTyped(json, false);
}

export function IAggregatorManualContributionRecordDtoToJSONTyped(value?: IAggregatorManualContributionRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contribution_date': value['contribution_date'] == null ? undefined : ((value['contribution_date']).toISOString().substring(0,10)),
        'tax_type': value['tax_type'],
        'tax_year': value['tax_year'],
        'employee_contribution_amount': value['employee_contribution_amount'],
        'employer_contribution_amount': value['employer_contribution_amount'],
        'ee_contribution_tag': value['ee_contribution_tag'],
        'er_contribution_tag': value['er_contribution_tag'],
        'plan_id': value['plan_id'],
        'plan_code': value['plan_code'],
        'plan_name': value['plan_name'],
        'employee_id': value['employee_id'],
        'employee_full_name': value['employee_full_name'],
        'memo': value['memo'],
    };
}

